import styled from 'styled-components';

export const CartItemWrapper = styled.div`
  display: flex;
`;

export const CartItemImageContainer = styled.div`
  width: 100px;
  margin-right: 12px;
`;

export const CartItemDetails = styled.div`
  width: 100%;
`;

export const CartItemHeadings = styled.div`
  margin-bottom: 10px;
`;

export const ItemProperty = styled.div`
  word-break: break-word;
`;

export const CartItemSubHeading = styled(ItemProperty)`
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const CartItemName = styled(ItemProperty)`
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.1px;
  line-height: 16px;
`;

export const CartItemImage = styled.img`
  object-fit: contain;
  max-width: 90px;
`;

export const CartPrice = styled.div`
  font-size: 14px;
  font-weight: bold;
  height: 16px;
  letter-spacing: 0.47px;
  line-height: 16px;
  white-space: nowrap;
`;

export const CartItemError = styled.div`
  font-size: 14px;
  letter-spacing: 0.47px;
  line-height: 16px;
  margin-top: 24px;
  height: auto;
  font-weight: normal;
  white-space: normal;
`;
